import * as React from "react";
import Section from "./layout/Section";
import Keyword from "./typography/Keyword";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/solid";
import { twMerge } from "tailwind-merge";

export const Comparison = (props: {
  pros: {
    title: string;
    elements: string[];
  };
  cons: { title: string; elements: string[] };
}) => {
  return (
    <Section theme="white">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
        {[
          {
            title: props.cons.title,
            titleClass: "",
            items: props.cons.elements,
            Icon: XCircleIcon,
            iconColor: "text-red-500",
          },
          {
            title: props.pros.title,
            titleClass: "font-bold",
            items: props.pros.elements,
            Icon: CheckCircleIcon,
            iconColor: "text-green-500",
          },
        ].map((block, i) => (
          <div
            key={`comparison-${i}`}
            className="bg-gray-100 py-8 px-4 lg:px-10 xl:px-16 md:py-12"
          >
            <h4 className={twMerge("text-4xl mb-4", block.titleClass)}>
              {block.title}
            </h4>
            <ul className="list-disc list-inside space-y-2">
              {block.items.map((item, index) => (
                <li
                  key={index}
                  className="text-gray-800 list-none flex items-center space-x-4"
                >
                  <block.Icon
                    className={twMerge(
                      "h-6 md:h-8 w-6 md:w-8 shrink-0",
                      block.iconColor,
                    )}
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Section>
  );
};
